import { useState, useEffect } from "react";
import Select from 'react-select';
import {AssociatedInsuranceInformation, AssociatedFinancingInformation, AssociatedOpportunities} from "./RelatedTables";
import {AccountDetailsRelatedTabSkeleton} from "./skeleton/AccountDetailsSkeleton";
import {useAccDetRelated} from "../../api/account/useAccDetRelated";
import {useAccDetAssociatedInfo} from "../../api/account/useAccDetAssociatedInfo";
import {useGetCountryCurrency} from "../../api/auth/useGetCountryCurrency";
import { apiRequest } from "../../network/apiClient";
import { API_ENDPOINTS } from "../../api/apiEndpoints";

import { useLocation,useParams } from "react-router-dom";
import { toast } from "react-toastify";

const RelatedTab = ({ leadID, accountOwner }) => {
    const location = useLocation();
    const params = useParams();
    const [isEditing, setIsEditing] = useState(false);
    const handleEditClick = () => {
        setIsEditing(!isEditing);
    };

    const {currencyList, countryList} = useGetCountryCurrency();
    const {insuranceData, financingData, otherOppData, refetch} = useAccDetAssociatedInfo(leadID);
    const {infoGatheringAPI, loading, refetch: refetchRelated} = useAccDetRelated({lead_id: leadID});

    const [showInfoGatheringConfirmationModal, setShowInfoGatheringConfirmationModal] = useState(false);

    const curr_provider_list =["Affin Bank Berhad", "Al Rajhi Bank", "Alliance Bank Malaysia", "Ambank (M) Berhad", "Bank Islam Malaysia Berhad","CIMB Bank Berhad", "CIMB Islamic Bank Berhad", "Citibank Berhad", "Easypay", "Hawala", "Hong Leong Bank Berhad", "HSBC Bank Malaysia Berhad", "Instarem","Kuwait Finance House (Malaysia) Berhad", "Malayan Banking Berhad", "Maybank Islamic Berhad", "MerchantTrade","None","OCBC Alamin Bank Berhad","OCBC Bank (Malaysia) Berhad", "Public Bank Berhad", "RHB Bank Berhad", "Standard Chartered Bank Malaysia Berhad", "United Overseas Bank (Malaysia) Berhad", "Western Union", "Others"]
    const trade_fac_list = ['FCA', 'LC', 'BA', 'Hedging', 'Forward Contact', 'None - 100% TT']

    // Set the information for the form
    useEffect(() => {
        setInfoGathering(infoGatheringAPI);
        setInfoGatheringFormData(infoGatheringAPI);
    }, [infoGatheringAPI]);

    const [infoGathering, setInfoGathering] = useState({
        trade_facilities: [], // Initialize as an empty array
        current_provider: [],
        currencies: [],
        countries: [],
        // Other fields...
    });
    const [infoGatheringFormData, setInfoGatheringFormData] = useState({
        trade_facilities: [], // Initialize as an empty array
        current_provider: [],
        currencies: [],
        countries: [],
        next_expected_tt: infoGathering.next_expected_tt,
        // Other fields...
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        // const formattedValue = formatDateForDisplay(value);
    
        if (name === 'next_expected_tt') {
            
            setInfoGatheringFormData({
                ...infoGatheringFormData,
                [name]: value, // Store the raw `yyyy-MM` value in state
            });

        } else {
            // Update the form state
            setInfoGatheringFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));

            
        }
        
    };

    // Define options for multi-select dropdowns
    const tradeFacilitiesOptions = trade_fac_list.map(provider => ({
        value: provider, // Use the provider name as the value
        label: provider  // Use the provider name as the label
    }));

    const currentProviderOptions = curr_provider_list.map(provider => ({
        value: provider, // Use the provider name as the value
        label: provider  // Use the provider name as the label
    }));

    const currenciesOptions = currencyList ? currencyList.map(currency => ({
        value: currency,
        label: currency
    })) : [];


    const countriesOptions = countryList ? countryList.map(country => ({
        value: country,
        label: country
    })) : [];

    // Handle change for multi-select dropdowns
    const handleMultiSelectChange = (selectedOptions, fieldName) => {
        setInfoGatheringFormData(prevState => ({
            ...prevState,
            [fieldName]: selectedOptions.map(option => option.value)
        }));
    };

    // Convert array values to options for react-select
    const getSelectedOptions = (values, options) => {
        return options.filter(option => values.includes(option.value));
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            // Fallback if the date string is invalid
            return '';
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
    };
    
    const formatDateForDisplay = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            // Fallback if the date string is invalid
            return '';
        }
        return date.toLocaleString('default', { month: 'long' }) + ' ' + date.getFullYear();
    };


    const handleCancelInfoGathering = () => {
        setIsEditing(false); // Exit edit mode
        // setIFormData(leadJourney); // Revert form data back to the original leadJourney data
        setShowInfoGatheringConfirmationModal(false)
        setInfoGatheringFormData(infoGathering)
    };

    const handleSubmitInfoGathering = () => {
        setShowInfoGatheringConfirmationModal(true); 
    };

    const handleInfoGatheringConfirmation = async () => {
        // Convert the date to the backend's expected format
        const formattedData = {
            ...infoGatheringFormData,
            next_expected_tt: formatDateForDisplay(infoGatheringFormData.next_expected_tt),
        };
        // console.log(formattedData)
        try{
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.UPDATE_ACCOUNTS.INFO_GATHERING}?lead_id=${leadID}`, 'POST', formattedData)
            toast.success("Successfully updated information")
            refetchRelated();
            setInfoGathering(infoGatheringAPI)
            setInfoGatheringFormData(infoGatheringAPI)
            setIsEditing(false)
        } catch (error) {
            toast.error(error || "Error updating information")
        }finally{
            setShowInfoGatheringConfirmationModal(false)
        }
    };
    if (loading) {
        return <AccountDetailsRelatedTabSkeleton />;
    }

    return(
        <div className='w-full bg-white p-7 rounded-3xl shadow-lg'>
            {/* Lead Ownership Section */}
            <div className="flex justify-between items-start">
                <div className="flex items-center">
                    <p className="font-bold text-2xl text-[#1E293B]">Associated TT Information</p>
                </div>
                <div className="flex space-x-2">
                    {isEditing && (
                        <button
                            className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-gray-200 transition flex items-center justify-center w-12 h-12"
                            onClick={handleCancelInfoGathering}
                            aria-label="Cancel Editing"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="size-6"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M6 18 18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    )}
                    {accountOwner && (
                        <button
                            className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-yellow-300 transition flex items-center justify-center w-12 h-12"
                            onClick={isEditing ? handleSubmitInfoGathering : handleEditClick}
                            aria-label={isEditing ? 'Submit' : 'Edit Lead'}
                        >
                            {isEditing ? (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="size-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="m4.5 12.75 6 6 9-13.5"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="size-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                                    />
                                </svg>
                            )}
                        </button>
                    )}
                </div>
            </div>

            {/* Grid Container for All Rows */}
            <div className="grid grid-cols-2 gap-x-5 ml-5 text-[#475569]">
                {/* Company Name and Hunter */}
                <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Frequency of TT</b></span>
                        {isEditing ? (
                            <select
                                name="frequency"
                                value={infoGatheringFormData.frequency || ''}
                                onChange={handleChange}
                                className="flex-1"
                            >
                                <option value={null} ></option>
                                <option value="Every Month">Every Month</option>
                                <option value="Every 2-3 Months">Every 2-3 Months</option>
                                <option value="Every Quarter">Every Quarter</option>
                                <option value="1-3 Times a Year">1-3 Times a Year</option>
                            </select>
                        ) : (
                            <div className="flex-1 flex items-center">
                                {infoGatheringFormData.frequency}
                            </div>
                        )}
                    </div>
                </div>
                <div className="flex items-start mt-5">
                    <p className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Next Expected TT</b></span>
                        {isEditing ? (
                            <input
                                type="month"
                                name="next_expected_tt"
                                // value={infoGatheringFormData.next_expected_tt || ''}
                                value={formatDateForInput(infoGatheringFormData.next_expected_tt) || ''}
                                onChange={handleChange}
                                className="flex-1 mr-6"
                            />
                        ) : (
                            <span className="flex-1">
                                {infoGatheringFormData.next_expected_tt}
                            </span>
                        )}
                    </p>
                </div>

                {/* Contact Method and Lead Source */}
                <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Average TT Amount</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="average_tt_amount"
                                value={infoGatheringFormData.average_tt_amount || ''}
                                onChange={handleChange}
                                className="flex-1"
                            />
                        ) : (
                            <span className="flex-1">
                                {infoGatheringFormData.average_tt_amount}
                            </span>
                        )}
                    </div>
                </div>
                <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Previous TT Amount</b></span>
                        {isEditing ? (
                            <input
                                type="text"
                                name="previous_tt_amount"
                                value={infoGatheringFormData.previous_tt_amount || ''}
                                onChange={handleChange}
                                className="flex-1"
                            />
                        ) : (
                            <span className="flex-1">{infoGatheringFormData.previous_tt_amount || ''}</span>
                        )}
                    </div>
                </div>
                <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Tier</b></span>
                        {isEditing ? (
                            <select
                                name="tier"
                                value={infoGatheringFormData.tier || ''}
                                onChange={handleChange}
                                className="flex-1"
                            >
                                <option value={null} ></option>
                                <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                                <option value="D">D</option>
                            </select>
                        ) : (
                            <span className="flex-1">
                                {infoGatheringFormData.tier || ''}
                            </span>
                        )}
                    </div>
                </div>
                <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Current Provider</b></span>
                        {isEditing ? (
                            <Select
                                isMulti
                                options={currentProviderOptions}
                                value={getSelectedOptions(infoGatheringFormData.current_provider || [], currentProviderOptions)}
                                onChange={(selectedOptions) => handleMultiSelectChange(selectedOptions, 'current_provider')}
                                className="flex-1"
                            />
                        ) : (
                            <span className="flex-1">
                                {infoGathering.current_provider}
                            </span>
                        )}
                    </div>
                </div>
                <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Current Rates</b></span>
                        {isEditing ? (
                            <select
                                name="current_rates"
                                value={infoGatheringFormData.current_rates || ''}
                                onChange={handleChange}
                                className="flex-1"
                            >
                                <option value={null} ></option>
                                <option value="Counter Rate">Counter Rate</option>
                                <option value="Special Rate">Special Rate</option>
                                <option value="Close to Mid Rate">Close to Mid Rate</option>
                                <option value="Using Cash">Using Cash</option>
                            </select>
                        ) : (
                            <span className="flex-1">{infoGathering.current_rates || ''}</span>
                        )}
                    </div>
                </div>
                <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Trade Facilities</b></span>
                        {isEditing ? (
                            <Select
                                isMulti
                                options={tradeFacilitiesOptions}
                                value={getSelectedOptions(infoGatheringFormData.trade_facilities || [], tradeFacilitiesOptions)}
                                onChange={(selectedOptions) => handleMultiSelectChange(selectedOptions, 'trade_facilities')}
                                className="flex-1"
                            />
                        ) : (
                            <span className="flex-1">
                                {infoGathering.trade_facilities}
                            </span>
                        )}
                    </div>
                </div>
                <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Reason of using TF</b></span>
                        {isEditing ? (
                            <select
                                name="reason_tf"
                                value={infoGatheringFormData.reason_tf}
                                onChange={handleChange}
                                className="flex-1"
                            >
                                <option value={null} ></option>
                                <option value="Not using">Not using</option>
                                <option value="Others">Others</option>
                                <option value="Because our bank provides them">Because our bank provides them</option>
                                <option value="We need the cash flow">We need the cash flow</option>
                                <option value="We need the banks to verify the condition of goods">We need the banks to verify the condition of goods</option>
                                <option value="Other (Please Specify)">Other (Please Specify)</option>
                            </select>
                        ) : (
                            <span className="flex-1">
                                {infoGathering.reason_tf}
                            </span>
                        )}
                    </div>
                </div>
                <div className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/3"><b>Percentage of TT</b></span>
                        {isEditing ? (
                            <select
                                name="percentage_tt"
                                value={infoGatheringFormData.percentage_tt || ''}
                                onChange={handleChange}
                                className="flex-1"
                            >
                                <option value={null} ></option>
                                <option value="&lt;10%">&lt;10%</option>
                                <option value="&lt;25%">&lt;25%</option>
                                <option value="&lt;10%">&lt;50%</option>
                                <option value="&gt;10%">&gt;50%</option>
                                <option value="&gt;10%">&gt;75%</option>
                            </select>
                        ) : (
                            <span className="flex-1">{infoGathering.percentage_tt}</span>
                        )}
                    </div>
                </div>
                <div className="col-span-2 flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/6"><b>Currencies</b></span>
                        {isEditing ? (
                            <Select
                                isMulti
                                options={currenciesOptions}
                                value={getSelectedOptions(infoGatheringFormData.currencies || [], currenciesOptions)}
                                onChange={(selectedOptions) => handleMultiSelectChange(selectedOptions, 'currencies')}
                                className="flex-1 -ml-1"
                            />
                        ) : (
                            <span className="flex-1 -ml-1">
                                {infoGathering.currencies}
                            </span>
                        )}
                    </div>
                </div>
                <div className="col-span-2 flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                        <span className="w-1/6"><b>Target Country</b></span>
                        {isEditing ? (
                            <Select
                                isMulti
                                options={countriesOptions}
                                value={getSelectedOptions(infoGatheringFormData.target_countries || [], countriesOptions)}
                                onChange={(selectedOptions) => handleMultiSelectChange(selectedOptions, 'target_countries')}
                                className="flex-1 -ml-1"
                            />
                        ) : (
                            <span className="flex-1 -ml-1">
                                {infoGathering.target_countries}
                            </span>
                        )}
                    </div>
                </div>

                <div className="flex items-center mt-5 mb-5">
                    <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">Associated Insurance Information</p>
                </div>
                <br></br>
                <div className="col-span-2 mb-4">
                    <AssociatedInsuranceInformation data={insuranceData} />
                </div>
                <div className="flex items-center mt-5 mb-5">
                    <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">Associated Financing Information</p>
                </div>
                <br></br>
                <div className="col-span-2 mb-4">
                    <AssociatedFinancingInformation data={financingData} />
                </div>
                <div className="flex items-center mt-5 mb-5">
                    <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">Associated Opportunities</p>
                </div>
                <br></br>
                <div className="col-span-2 mb-4">
                    <AssociatedOpportunities data={otherOppData} />
                </div>
            </div>
            {showInfoGatheringConfirmationModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
                    
                    <div className="bg-white p-6 rounded-lg w-1/4">
                        {/* Center the icon using Flexbox */}
                        <div className="flex justify-center mb-2 pt-6">
                            <img src="/icons/edit.svg" className='size-11' />
                        </div>
        
                        <h1 className="text-2xl font-bold mb-3">Save & Update Info Gathering</h1>
                        <p>Info Gathering details will be updated. Please ensure new details are correct.</p>
                        <div className="mt-6 mb-6">
                            <button
                                className="text-black underline hover:text-blue-800 focus:outline-none"
                                onClick={handleCancelInfoGathering}
                            >
                                <b>No, Don't Update</b>
                            </button>
                            
                        </div>
                        <button
                                className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400"
                                onClick={handleInfoGatheringConfirmation}
                            >
                                <b>Save & Update</b>
                            </button>
                    </div>
                </div>
            )}


        </div>
    )
}

export default RelatedTab;